import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-accordion-trigger',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './accordion-trigger.component.html',
  styleUrls: ['./accordion-trigger.component.scss']
})
export class UmssAccordionTriggerComponent implements AfterContentInit {
  @HostBinding('style.display') display = 'contents';

  @ContentChild('content', { read: ElementRef }) projectedContent?: ElementRef;

  hasProjectedContent = false;

  constructor() {}

  ngAfterContentInit(): void {
    // Check if content was projected
    this.hasProjectedContent = !!this.projectedContent;
  }

  /** Content props */
  @Input() label: string = '';

  /** State props */
  @Input() isOpen: boolean = false;
  @Input() disabled: boolean = false;

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';

  /** Event outputs */
  @Output() toggle = new EventEmitter<void>();

  /** Event handlers */
  onTriggerClick(): void {
    if (this.disabled) return;
    this.toggle.emit();
  }
}
